import { useObservableBlock } from 'src/services/rxjs-redux/hook';

export const usePropertySegments = (recordId: string, propertyId: string) => {
  return useObservableBlock(recordId, (block) => block?.data.collectionProperties?.[propertyId], [
    propertyId,
  ]);
};
